import React, { type ReactNode } from "react";

type CsMessageTextContentProps = {
  content: string;
  renderInline?: (text: string) => ReactNode;
};

function normalizeNewlines(text: string): string {
  return text.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
}

/** 按 \n 分行展示，每行独立成块以便控制段间距 */
export function CsMessageTextContent({ content, renderInline }: CsMessageTextContentProps) {
  const render = renderInline ?? ((text: string) => text);
  const lines = normalizeNewlines(content).split("\n");

  return (
    <>
      {lines.map((line, i) => (
        <span key={i} className="cs-msg-paragraph">
          {render(line)}
        </span>
      ))}
    </>
  );
}

export default CsMessageTextContent;
